import {Fragment} from "react";
import {Button} from "@mantine/core";
import {useTranslation} from "react-i18next";
import type {ChecklistFilterGroup} from "../types";
import ClearSvg from "../../../assets/v2-remove-square.svg?react";
import styles from "./checklist.module.css";

type NoContentProps = {
    searchTerm: string;
    activeFilters: ChecklistFilterGroup[];
    onClearSearchAndFilters: () => void;
};

export const NoContent = ({
    searchTerm,
    activeFilters,
    onClearSearchAndFilters,
}: NoContentProps) => {
    const {t} = useTranslation();

    const statusFilterGroup = activeFilters.find(
        (f) => f.name === "status",
    );
    const otherFilterGroups = activeFilters.filter(
        (f) => f.name !== "status",
    );

    return (
        <div className={styles.noContent}>
            <h1>{t("Info.NoHits")}</h1>
            <div>
                <p>{t("Phrase.NoResultsOn")}:</p>
                <dl>
                    {searchTerm && (
                        <>
                            <dt>{t("Word.TheSearchText")}</dt>
                            <dd>{searchTerm}</dd>
                        </>
                    )}
                    {statusFilterGroup && (
                        <>
                            <dt>{t("Word.Status")}</dt>
                            <dd>
                                {statusFilterGroup.labels
                                    .map((l) => l.name)
                                    .join(", ")}
                            </dd>
                        </>
                    )}
                    {otherFilterGroups.map((filter) => (
                        <Fragment key={filter.name}>
                            <dt>{filter.name}</dt>
                            <dd>
                                {filter.labels
                                    .map((l) => l.name)
                                    .join(", ")}
                            </dd>
                        </Fragment>
                    ))}
                </dl>
            </div>
            <Button
                variant="subtle"
                color="gray"
                leftSection={<ClearSvg width={16} height={16} />}
                onClick={onClearSearchAndFilters}
            >
                {t("Phrase.RemoveFilters")}
            </Button>
        </div>
    );
};
